// extracted by mini-css-extract-plugin
var _1 = "input__KKPsQ";
export { _1 as "input" }
